module.exports = __webpack_public_path__ + "img/mission-diversity-board-face-6.jpg?2172d183308193f958cbab2f90b866a2";